import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("CARGAR_PROFESIONAL", newActions, newReducers);

const cargarProfesionalThunk = (data) => {
  const url = `${baseUrl}/profesional`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckEditProfesional = createDuck("EDITAR_PROFESIONAL", newActions, newReducers);

const editProfesionalThunk = (data) => {
  const url = `${baseUrl}/profesional`;
  return createThunk(axios, "patch", duckEditProfesional.actions, url, data);
};

const duckProfesionalById = createDuck("PROFESIONAL_BY_ID", newActions, newReducers);

const profesionalByIdThunk = (id) => {
  const url = `${baseUrl}/profesionalById/${id}`;
  return createThunk(axios, "get", duckProfesionalById.actions, url, null);
};

const duckEliminarImgProfesional = createDuck("ELIMINAR_IMG_PROFESIONAL");

const eliminarImgProfesionalThunk = (data) => {
  const url = `${baseUrl}/eliminarImgProfesional`;
  return createThunk(axios, "post", duckEliminarImgProfesional.actions, url, data);
};

export default {
  duck,
  cargarProfesionalThunk,
  duckEditProfesional,
  editProfesionalThunk,
  duckProfesionalById,
  profesionalByIdThunk,
  duckEliminarImgProfesional,
  eliminarImgProfesionalThunk,
};
